'use client';

import Image from 'next/image';
import Container from '@components/Container';
import AnimatedHeadings from '@components/AnimatedHeadings';
import AnimatedParagraphs from '@components/AnimatedParagraphs';
import skillsConfig from '@config/skillConfig';
import SkillsGesture from '@components/FramerMotion/Gestures';
import { Card, CardDescription, CardHeader } from '@components/ui/card';
import { useTranslations } from 'next-intl';
import styles from './index.module.scss';

const Skills = () => {
  const t = useTranslations('skills');
  return (
    <Container id={'skills'} dataId={'skills'}>
      <AnimatedHeadings
        el="h1"
        className={styles.sectionTitle}
        text={t('heading')}
        repeatDelay={10000}
      />
      <AnimatedParagraphs className="text-base sm:text-lg md:text-xl">
        {t('description')}
      </AnimatedParagraphs>

      <div className={styles.wrapper}>
        <div className={styles.cardWrapper}>
          {skillsConfig.map((technology) => {
            return (
              <SkillsGesture key={technology.title}>
                <Card className={styles.technology}>
                  <CardHeader>
                    <CardDescription className={styles.title}>
                      {technology.title}
                    </CardDescription>
                    <Image
                      src={technology.logo}
                      height={80}
                      width={80}
                      alt="technology logo"
                      className={styles.image}
                    />
                  </CardHeader>
                </Card>
              </SkillsGesture>
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default Skills;
